import React from 'react'
import Navbar from '../components/Navbar'
import { Container, Opening, Section, Frag, ImgCon, Title, Sub, ColL, ColR, Num, Wrapper, TagConL, TagConR, Tag, Button } from '../assets/styles/projectElements'
import Img1 from '../assets/images/pix.png'
import Img2 from '../assets/images/bab.png'
import Img3 from '../assets/images/cr.png'
import Img4 from '../assets/images/ppt.png'
import Img5 from '../assets/images/arena.png'
import Img6 from '../assets/images/sort.png'
import Img7 from '../assets/images/todo.png'
import Img8 from '../assets/images/ss.png'

const Project = () => {

    const image = {
        width: 900,
    }

    return (
        <>
            <Navbar />
            <Wrapper>
                <Section>
                    <Container style={{ backgroundColor: 'white' }}>
                        <Opening>
                            <h1><span style={{ color: '#333333' }} >My </span>Projects</h1>
                        </Opening>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#FEF8F1' }}>
                        <Frag>
                            <ColL>
                                <Title style={{ color: '#FC9B9B' }}>PIXELLARY</Title>
                                <TagConL>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>MongoDB</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>ExpressJS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>React</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>NodeJS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>HTML</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>CSS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>JS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>Firebase</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>Github</Tag>
                                </TagConL>
                                <Sub style={{ color: '#333333' }}>A minimal photo gallery
                                app with beutiful UI and
                                smooth animation.</Sub>
                                <Button href='https://pixallary.web.app' target='_blank' style={{ backgroundColor: '#FC9B9B' }} >Check it out!</Button>
                                <Num style={{ color: '#FFD8D8', marginTop: '40px' }}>01</Num>
                            </ColL>
                        </Frag>
                        <ImgCon>
                            <img src={Img1} alt='pixellary' style={image} />
                        </ImgCon>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#2A303C' }}>
                        <ImgCon>
                            <img src={Img2} alt='babble' style={image} />
                        </ImgCon>
                        <Frag>
                            <ColR>
                                <Title style={{ color: '#4E5C77', textAlign: 'right' }}>BABBLE</Title>
                                <TagConR>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>MongoDB</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>ExpressJS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>React</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>NodeJS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>HTML</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>CSS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>JS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>Firebase</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#424C5F' }}>Github</Tag>
                                </TagConR>
                                <Sub style={{ color: '#ffffff', textAlign: 'right' }}>Another minimal app
                                where you can chat with
                                your friends in a chatroom
                                and have a great time.</Sub>
                                <Button href='https://chat-app-16c12.web.app/' target='_blank' style={{ backgroundColor: '#424C5F', color: '#fff' }}>Check it out!</Button>
                                <Num style={{ color: '#4E5C77', textAlign: 'right', marginTop: '20px' }}>02</Num>
                            </ColR>
                        </Frag>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#F3F3F3' }} >
                        <Frag>
                            <ColL>
                                <Title style={{ color: '#8FE3B6' }}>COLLEGE RANKER</Title>
                                <TagConL>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>PHP</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>HTML</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>CSS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>AWS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#4e4e4e' }}>Figma</Tag>
                                </TagConL>
                                <Sub style={{ color: '#333333' }}>Looking for College?
                                Here at college ranker, you can find
                                the best suited college for you
                                based on your preference.</Sub>
                                <Button style={{ backgroundColor: '#8FE3B6', color: '#333', width: '200px', cursor: 'not-allowed' }}>Currently Offline!</Button>
                                <Num style={{ color: '#C8EAD8' }}>03</Num>
                            </ColL>
                        </Frag>
                        <ImgCon>
                            <img src={Img3} alt='cr' width='750' />
                        </ImgCon>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#1D1D1D' }}>
                        <ImgCon>
                            <img src={Img4} alt='ping pong' width='650' />
                        </ImgCon>
                        <Frag>
                            <ColR>
                                <Title style={{ color: '#C5C500', textAlign: 'right' }}>PING PONG TENNIS</Title>
                                <TagConR>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>Java</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>Applet</Tag>
                                </TagConR>
                                <Sub style={{ color: '#E7E7E7', textAlign: 'right' }}>Missed those retro game you used to play as a child?
                                Here, it is I present to you the most common retro game
                                of all time, “The Ping Pong”. This game is made purely
                                using JAVA and Applet.</Sub>
                                <Button href='https://github.com/bhaweshverma50/Ping-Pong-Tennis' target='_blank' style={{ backgroundColor: '#C5C500', color: '#333' }}>Check it out!</Button>
                                <Num style={{ color: '#696907', textAlign: 'right', marginTop: '60px' }}>04</Num>
                            </ColR>
                        </Frag>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#BCDBF3' }}>
                        <Frag>
                            <ColL>
                                <Title style={{ color: '#73A9D3' }}>CODE ARENA</Title>
                                <TagConL>
                                    <Tag style={{ color: '#333', backgroundColor: '#F9D65D' }}>Python</Tag>
                                    <Tag style={{ color: '#333', backgroundColor: '#F9D65D' }}>Django</Tag>
                                    <Tag style={{ color: '#333', backgroundColor: '#F9D65D' }}>HTML</Tag>
                                    <Tag style={{ color: '#333', backgroundColor: '#F9D65D' }}>CSS</Tag>
                                    <Tag style={{ color: '#333', backgroundColor: '#F9D65D' }}>Figma</Tag>
                                    <Tag style={{ color: '#333', backgroundColor: '#F9D65D' }}>AWS</Tag>
                                </TagConL>
                                <Sub style={{ color: '#274963' }}>This is the place where you can practice and
                                improve your coding skills with our online
                                compiler. You can choose any language
                                of your choice and run your code online
                                without any hassle.</Sub>
                                <Button style={{ backgroundColor: '#73A9D3', color: '#274963', width: '200px', cursor: 'not-allowed' }}>Currently Offline!</Button>
                                <Num style={{ color: '#A7CAE5', marginTop: '40px' }}>05</Num>
                            </ColL>
                        </Frag>
                        <ImgCon>
                            <img src={Img5} alt='code arena' width='750' />
                        </ImgCon>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#303334' }}>
                        <ImgCon>
                            <img src={Img6} alt='sortlizer' width="820" />
                        </ImgCon>
                        <Frag>
                            <ColR>
                                <Title style={{ color: '#EB574A', textAlign: 'right' }}>SORTLIZER</Title>
                                <TagConR>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>HTML</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>CSS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>JS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>Bootstrap</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#545454' }}>Github</Tag>
                                </TagConR>
                                <Sub style={{ color: '#E7E7E7', textAlign: 'right' }}>It is a sorting visualizer website
                                made using purely HTML, CSS and JS. There are various algorithm to select and see how
                                they work in the speed you
                                desire.</Sub>
                                <Button href='https://bhaweshverma50.github.io/Sortilizer/' target='_blank' style={{ backgroundColor: '#EB574A', color: '#fff' }}>Check it out!</Button>
                                <Num style={{ color: '#754541', textAlign: 'right', marginTop: '20px' }}>06</Num>
                            </ColR>
                        </Frag>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#49A2EA' }}>
                        <Frag>
                            <ColL>
                                <Title style={{ color: '#94CFFF' }}>TO-DO LIST</Title>
                                <TagConL>
                                    <Tag style={{ color: '#fff', backgroundColor: '#2D88D1' }}>HTML</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#2D88D1' }}>CSS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#2D88D1' }}>JS</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#2D88D1' }}>Figma</Tag>
                                </TagConL>
                                <Sub style={{ color: '#ffffff' }}>A very simple To-Do app which you can
                                use to check on your daily task or work.
                                It does not need internet to save your data
                                and is completely responsible on every
                                device you own.</Sub>
                                <Button style={{ backgroundColor: '#2D88D1', color: '#fff', width: '200px', cursor: 'not-allowed' }}>Currently Offline!</Button>
                                <Num style={{ color: '#3B97E1', marginTop: '5px' }}>07</Num>
                            </ColL>
                        </Frag>
                        <ImgCon>
                            <img src={Img7} alt='todo' style={image} />
                        </ImgCon>
                    </Container>
                </Section>
                <Section>
                    <Container style={{ backgroundColor: '#221C3E' }}>
                        <ImgCon>
                            <img src={Img8} alt='sortlizer' height="550" style={{ borderRadius: '25px', marginLeft: '50px' }} />
                        </ImgCon>
                        <Frag>
                            <ColR>
                                <Title style={{ color: '#8674DA', textAlign: 'right' }}>SPACE SHOOTER</Title>
                                <TagConR>
                                    <Tag style={{ color: '#fff', backgroundColor: '#431294' }}>Python</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#431294' }}>PyGame</Tag>
                                    <Tag style={{ color: '#fff', backgroundColor: '#431294' }}>Github</Tag>
                                </TagConR>
                                <Sub style={{ color: '#FFFFFF', textAlign: 'right' }}>Another vintage old school game recreated using Python’s PyGame library. Just a basic version of the game with all physics and mechanics implemented.</Sub>
                                <Button style={{ backgroundColor: '#431294', color: '#fff', width: '200px', cursor: 'not-allowed' }}>Currently Offline!</Button>
                                <Num style={{ color: '#493F79', textAlign: 'right', marginTop: '80px' }}>08</Num>
                            </ColR>
                        </Frag>
                    </Container>
                </Section>
            </Wrapper>
        </>
    )
}

export default Project